import axios, { CancelTokenSource } from 'axios'
import { Message } from 'element-ui'
import { getTokenWhitCookie } from '@ps/utils/auth'
import { v2Host } from '@/config/host'
import { logout } from '@ve-pro/utils/auth'
import { t } from '../ve/lang'
import { localLanguage } from '@/common/storage'
// 0: 正常，1：其他错误，2：未登录，4：权限错误
enum ResponseCode {
  Success = 0,
  Other = 1,
  Unlogin = 2,
  Authorization = 4,
}

const REQUEST_CANCEL_MESSAGE = `__request_cancel__`

export type RequestResponse<T = unknown> = {
  code: ResponseCode
  msg?: string
  data: T
}

// 此项目列表返回的数据格式
export type ResponseList<T = any> = {
  list: T | null
  page: number
  page_size: number
  total: number
}

const service = axios.create({
  baseURL: v2Host, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000, // request timeout
})

const isFormData = (v: any) => {
  return Object.prototype.toString.call(v) === '[object FormData]'
}
service.interceptors.request.use(
  (config) => {
    config.headers['auth-token'] = getTokenWhitCookie()

    // http header 加语言
    // const lang = i18n.locale
    const lang = localLanguage.get()
    if (lang) {
      config.headers['Accept-Language'] = lang
    }

    const contentType = config.headers['Content-Type']

    if (
      contentType !== 'application/json' &&
      ['POST', 'post'].includes(config.method as string) &&
      !isFormData(config.data)
    ) {
      const formData = new FormData()
      for (const key in config.data) {
        const value = config.data[key]
        formData.append(
          key,
          typeof value === 'string' ? value : JSON.stringify(value),
        )
      }
      config.data = formData
    }
    return config
  },

  //   (error) => {
  //     // do something with request error
  //     console.log(error) // for debug
  //     return Promise.reject(error)
  //   },
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const data = response.data
    // 未登录或 token 失效去读取接口
    if (data.code === ResponseCode.Unlogin) {
      logout()
      return Promise.reject(response)
    } else if (data.code === ResponseCode.Authorization) {
      return Promise.reject(response)
    } else if (data.code === ResponseCode.Other) {
      Message({
        message: data.msg,
        type: 'error',
        duration: 5 * 1000,
        showClose: true,
      })
      return Promise.reject(response)
    }

    return response
  },
  (error) => {
    if (error.message === REQUEST_CANCEL_MESSAGE) {
      //
    } else {
      Message({
        message: error?.data?.msg ?? t('network.error'),
        type: 'error',
        duration: 3 * 1000,
        showClose: true,
      })
    }
    return Promise.reject(error)
  },
)

export const request = service

export function cancelRequest(source: CancelTokenSource): void {
  source.cancel(REQUEST_CANCEL_MESSAGE)
}
